export default __webpack_public_path__ + "static/media/nest.a27e78d1.png";